import React, { useState } from 'react';

const LayoutPlantDropdown = ({ plantas, setCurrentPage, onSelectPlant }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handlePlantClick = (plantId) => {
    onSelectPlant(plantId);
    setCurrentPage('plantasView');
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors flex items-center space-x-2 font-medium"
      >
        <span>Ver Plantas</span>
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-10 border border-gray-200">
          {plantas.map(plant => (
            <button
              key={plant.id}
              onClick={() => handlePlantClick(plant.id)}
              className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors"
            >
              {plant.nombre}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayoutPlantDropdown;